<div #menuContainer
     class="td-wb-mobile-flyout-menu-nav"
     (swipeleft)="swipeLeft()">
  @if (menu === undefined) {
    <ng-content />
  }
  @if (menu !== undefined) {
    <ng-container *ngTemplateOutlet="content(); context: { $implicit: menu }" />
  }
</div>
